module.exports = __webpack_public_path__ + "img/ProTips.2580d3c0.png";